import { useEffect, useRef } from 'react';

import { findOrCreateWuid } from '@breeze/web-lib-wuid';
import { collectFingerprint } from '@breezeventures/web-lib-fingerprint/collect';

interface FingerprintParams {
  apiUrl: string;
  userId: string;
  wuid: string;
}

declare global {
  interface Window {
    initializeAnyId?: (params: FingerprintParams) => Promise<void>;
  }
}

interface UseFingerprintInitParams {
  apiUrl: string;
  userId: string | null;
  isAuthenticated: boolean;
}

export const useFingerprintInit = ({
  apiUrl,
  userId,
  isAuthenticated,
}: UseFingerprintInitParams) => {
  const initializedUserRef = useRef<string | null>(null);

  useEffect(() => {
    if (!isAuthenticated || !userId || initializedUserRef.current === userId) {
      return;
    }

    collectFingerprint({
      wuid: findOrCreateWuid(),
      apiUrl,
      additionalProperties: {
        userId,
      },
    });

    initializedUserRef.current = userId;
  }, [apiUrl, userId, isAuthenticated]);
};
